{
  "default": {
    "supportButton": {
      "label": "Obtenir de l'aide"
    }
  }
}
